/**
 * In JS, the modulo operator `%` does not normalize negative numbers.
 *
 * i.e. -1 % 3 = -1
 *
 * This function normalizes the result to always be positive.
 *
 * i.e. mod(-1, 3) = 2
 */
export function mod(a: number, b: number) {
  return ((a % b) + b) % b;
}
